import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineThickness: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLineThickness"><Path d="M4 5.5L20 5.5" stroke="currentColor"/><Path d="M4 17.5L20 17.5" stroke="currentColor" strokeWidth="3"/><Path d="M4 11L20 11" stroke="currentColor" strokeWidth="2"/></CentralIconBase>;
});

export default IconLineThickness;
